// @flow

import React, { Component } from 'react';
import animationHelper      from 'helpers/animation.helper';
import './goTop.css';

// Component that is used to show scroll to top icon on the selected position
//  All @params are received via props.
//  @param positionx    = horizontal position ['right', 'left']     String
//  @param positiony    = vertical position   ['top', 'bottom']     String
//  @param scrolloffset = scrool offset in px                       Number
class GoTop extends Component {

  goTop           = null;
  // Default values
  scrollY_padding = 100;
  positionXClass  = 'right';
  positionYClass  = 'bottom';

  componentWillMount() {
    const { positionx, positiony, scrolloffset } = this.props;

    if( positionx && positionx !== '' ) {
      this.positionXClass = positionx;
    }
    if( positiony && positiony !== '' ) {
      this.positionYClass = positiony;
    }
    if( scrolloffset ) {
      this.scrollY_padding = Number(scrolloffset);
    }
  }

  componentDidMount() {
    // Add onscroll event
    window.addEventListener('scroll', this._handleScroll);
  }

  render() {
    let positionClass = this.positionXClass + ' ' + this.positionYClass;
    return (
      <div className={'goTop ' + positionClass} ref={(element) => { this.goTop = element; }}>
        <a onClick={this._handleClick}><i className="fa fa-caret-up"></i></a>
      </div>
    );
  }

  _handleClick = (e: any) => {
    animationHelper.scrollTo('', 0, 500);
  }

  _handleScroll = (e: any) => {
    const { scrollY } = window;
    if( !this.goTop ) return false;

    if( scrollY >= this.scrollY_padding ) {
      if( this.goTop && !this.goTop.classList.contains('fadeIn') ) {
        this.goTop.classList.add('fadeIn');
      }
    } else {
      this.goTop.classList.remove('fadeIn');
    }
  }
}

export default GoTop;



// WEBPACK FOOTER //
// ./src/components/common/goTop/goTop.js